/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const sort = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.051 2v11.115M1.436 10.5l2.615 2.615L6.667 10.5m5.23 2.833V2.218m2.616 2.615-2.616-2.615-2.615 2.615"
    />
  </svg>
)
export default sort
